import { FC, Fragment } from 'react'
import { HighlightedTextProps } from './types'

export const HighlightedText: FC<HighlightedTextProps> = ({
  text,
  highlight
}) => {
  let parts
  if (!highlight.trim()) {
    parts = [{ text, isHighlight: false }]
  } else {
    try {
      // Escape special regex characters to prevent errors
      const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const regex = new RegExp(`(${escapedHighlight})`, 'gi')
      // Split with capture groups to preserve the matched text
      const splitParts = text.split(regex)
      // Create a new regex instance for testing to avoid lastIndex issues
      const testRegex = new RegExp(regex.source, 'i')
      parts = splitParts.map(part => ({
        text: part,
        isHighlight: testRegex.test(part)
      }))
    } catch {
      parts = [{ text, isHighlight: false }]
    }
  }

  return (
    <>
      {parts.map((part, i) =>
        part.isHighlight ? (
          <span key={i} className="bg-yellow-200 font-medium">
            {part.text}
          </span>
        ) : (
          <Fragment key={i}>{part.text}</Fragment>
        )
      )}
    </>
  )
}
